import produce from 'immer';

export const getChangedEvaluationForm = ({
  tableDataSource,
  name,
  changedValue,
}) => {
  const { propertyName, changedProperty } = getUpdatedFieldInfo(name);

  const foundIndex = tableDataSource.findIndex(
    (item) => item.property.name === propertyName
  );

  return produce(tableDataSource, (draftFile) => {
    draftFile[foundIndex][`${changedProperty}`] = changedValue;
  });
};

export const getChangedHeaderNamePhotoLabelEvalForm = ({
  tableDataSource,
  name,
  changedValue,
}) => {
  const [propertyName, index, changedProperty] = name;

  return produce(tableDataSource, (draftFile) => {
    draftFile[propertyName][index][`${changedProperty}`] = changedValue;
  });
};

export const getValueOfFieldEvaluationForm = ({
  indexOfFields,
  tableDataSource,
}) => {
  const { propertyName, changedProperty } = getUpdatedFieldInfo(indexOfFields);

  const foundIndex = tableDataSource.findIndex(
    (item) => item.property.name === propertyName
  );

  return tableDataSource[foundIndex][`${changedProperty}`];
};

export const getUpdatedFieldInfo = (indexOfFields) => {
  return {
    propertyName: indexOfFields[0],
    changedProperty: indexOfFields[indexOfFields.length - 1],
  };
};
